// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_template {
  border-radius: 10px;
  border: 2px solid rgb(36, 190, 225);
  transition: border-color 0.8s ease; 
  margin-top: 10px;
  margin-bottom: 10px !important;

}

.image_template:hover {
  border-color: blue; 
  border-width: 3px; 
}

.con1:hover .image_template {
  border-color: blue;
  border-width: 10px;
}

.bk-temp{

  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  display: block;
}


.con1 {
  cursor: pointer;
}




.mainbox {
  
  text-align: start; 
  padding: 10px;
}







.profile {
  overflow: hidden;
  position: relative;
}

.proimg {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 2px solid rgb(126, 155, 189);
  position: absolute;
  left: 50%;
  top: 25%;
  transform: translate(-50%, -50%);
  z-index: 9;
}

.bbox {
  width: 257px;
  height: 407px;
}

.name {
  color: rgb(82, 78, 78);
  text-align: center;
  margin-top: -215px;
  font-size: 30px;
  letter-spacing: 2px;
  font-weight: 400;
  text-transform: uppercase;
  font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif;
}

.hr {
  width: 80%;
  height: 6px;
  margin-left: 30px;
  border: 2px solid rgb(17, 16, 16);
}

.contact {
  margin: 10px;
}

#pt {
  background-color: rgb(247, 252, 252);
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.mainbox:nth-child(odd) {
  background-color: rgb(218, 218, 235); 
}

.mainbox:nth-child(even) {
  background-color: white;
}
  
.button1.use {
  background: #1ABC9C !important;
  border: none;
  border-radius: 10px;
  position: absolute;
  bottom: 26.5rem;
  left: 90%;
  transform: translateX(-50%);
}
@media (max-width: 1024px) {
  .button1.use {
    bottom: 20rem;  /* Adjust the bottom position for medium screens */
    left: 85%;      /* Adjust left position for better centering */
  }
}

/* For screens smaller than or equal to 767px (Mobile screens) */
@media (max-width: 767px) {
  .button1.use {
    bottom: 15rem;  /* Adjust the bottom position for mobile screens */
    left: 80% !important;      /* Adjust left position for better centering */
  }
  .button2.use {
    bottom: 15rem;  /* Adjust the bottom position for mobile screens */
    left: 80% !important;      /* Adjust left position for better centering */
  }
}
.button2.use {
  background: #1ABC9C !important;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/Template.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,kCAAoC;EACpC,gBAAgB;EAChB,8BAA8B;;AAEhC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,eAAe;AACjB;;;;;AAKA;;EAEE,iBAAiB;EACjB,aAAa;AACf;;;;;;;;AAQA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE;IACE,aAAa,GAAG,kDAAkD;IAClE,SAAS,OAAO,8CAA8C;EAChE;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,aAAa,GAAG,kDAAkD;IAClE,oBAAoB,OAAO,8CAA8C;EAC3E;EACA;IACE,aAAa,GAAG,kDAAkD;IAClE,oBAAoB,OAAO,8CAA8C;EAC3E;AACF;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd","sourcesContent":[".image_template {\r\n  border-radius: 10px;\r\n  border: 2px solid rgb(36, 190, 225);\r\n  transition: border-color 0.8s ease, ; \r\n  margin-top: 10px;\r\n  margin-bottom: 10px !important;\r\n\r\n}\r\n\r\n.image_template:hover {\r\n  border-color: blue; \r\n  border-width: 3px; \r\n}\r\n\r\n.con1:hover .image_template {\r\n  border-color: blue;\r\n  border-width: 10px;\r\n}\r\n\r\n.bk-temp{\r\n\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  display: block;\r\n}\r\n\r\n\r\n.con1 {\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n.mainbox {\r\n  \r\n  text-align: start; \r\n  padding: 10px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.profile {\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.proimg {\r\n  width: 160px;\r\n  height: 160px;\r\n  border-radius: 50%;\r\n  border: 2px solid rgb(126, 155, 189);\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 25%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 9;\r\n}\r\n\r\n.bbox {\r\n  width: 257px;\r\n  height: 407px;\r\n}\r\n\r\n.name {\r\n  color: rgb(82, 78, 78);\r\n  text-align: center;\r\n  margin-top: -215px;\r\n  font-size: 30px;\r\n  letter-spacing: 2px;\r\n  font-weight: 400;\r\n  text-transform: uppercase;\r\n  font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.hr {\r\n  width: 80%;\r\n  height: 6px;\r\n  margin-left: 30px;\r\n  border: 2px solid rgb(17, 16, 16);\r\n}\r\n\r\n.contact {\r\n  margin: 10px;\r\n}\r\n\r\n#pt {\r\n  background-color: rgb(247, 252, 252);\r\n  margin: auto;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n}\r\n\r\n.mainbox:nth-child(odd) {\r\n  background-color: rgb(218, 218, 235); \r\n}\r\n\r\n.mainbox:nth-child(even) {\r\n  background-color: white;\r\n}\r\n  \r\n.button1.use {\r\n  background: #1ABC9C !important;\r\n  border: none;\r\n  border-radius: 10px;\r\n  position: absolute;\r\n  bottom: 26.5rem;\r\n  left: 90%;\r\n  transform: translateX(-50%);\r\n}\r\n@media (max-width: 1024px) {\r\n  .button1.use {\r\n    bottom: 20rem;  /* Adjust the bottom position for medium screens */\r\n    left: 85%;      /* Adjust left position for better centering */\r\n  }\r\n}\r\n\r\n/* For screens smaller than or equal to 767px (Mobile screens) */\r\n@media (max-width: 767px) {\r\n  .button1.use {\r\n    bottom: 15rem;  /* Adjust the bottom position for mobile screens */\r\n    left: 80% !important;      /* Adjust left position for better centering */\r\n  }\r\n  .button2.use {\r\n    bottom: 15rem;  /* Adjust the bottom position for mobile screens */\r\n    left: 80% !important;      /* Adjust left position for better centering */\r\n  }\r\n}\r\n.button2.use {\r\n  background: #1ABC9C !important;\r\n  border: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
